import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App';
import axios from './http';
import router from './router';

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});

Vue.prototype.GLOBAL = {
  lang: 'cn',
};

Vue.prototype.axios = axios;
Vue.config.productionTip = false;
Vue.use(ElementUI);
/* eslint-disable no-new */



new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: {
    App,
  },
});



// WEBPACK FOOTER //
// ./src/main.js